import * as Yup from 'yup'

export const InfluencerSchema = Yup.object().shape({
  full_name: Yup.string().required('This field is required.'),
  email: Yup.string()
  .required('Required')
  .email('Invalid email')
});